import { useState } from 'react'

import { isAxiosError } from 'axios'
import { signOut } from 'next-auth/react'
import { toast } from 'sonner'

import { api } from '@/shared/services/api'

/**
 * Solicitação de exclusão de conta (LGPD): confirma a senha, abre a carência de
 * 30 dias e desativa a conta na API (revogando os tokens). Em seguida encerra a
 * sessão local. Erros de senha voltam por `fieldError`.
 */
export function useAccountDeletion() {
  const [isLoading, setIsLoading] = useState(false)
  const [done, setDone] = useState(false)
  const [fieldError, setFieldError] = useState<string | null>(null)

  const requestDeletion = async (currentPassword: string) => {
    setIsLoading(true)
    setFieldError(null)
    try {
      await api.post('/user/data_requests', {
        kind: 'deletion',
        current_password: currentPassword
      })
      setDone(true)
      toast.success('Solicitação de exclusão registrada.')
      // Conta desativada e tokens revogados: encerra a sessão.
      setTimeout(() => signOut({ callbackUrl: '/' }), 3000)
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 422) {
        const errors = error.response.data?.errors as Record<string, string[]>
        if (errors?.current_password) {
          setFieldError(errors.current_password.join(', '))
        } else if (errors?.base) {
          toast.error(errors.base.join(', '))
        }
      } else {
        toast.error('Não foi possível registrar a solicitação. Tente novamente.')
      }
    } finally {
      setIsLoading(false)
    }
  }

  return { requestDeletion, isLoading, done, fieldError }
}
